import { render, staticRenderFns } from "./final-report.vue?vue&type=template&id=6861c5b6&"
import script from "./final-report.vue?vue&type=script&lang=js&"
export * from "./final-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports